module.exports = require("@swa-ui/dotcom/src/placements/DestinationByThemePlacement/DestinationByThemePlacement.module.scss");